import { defineStore } from 'pinia'
import { ref } from 'vue'
import { defaultTheme } from '@/themes/defaultTheme'
import type { BrandingConfig } from '@/themes/types'

/** Branding/features/locales use built-in defaults until the backend exposes tenant configuration. */
export const useTenantStore = defineStore('tenant', () => {
  const branding = ref<BrandingConfig>(defaultTheme)
  const features = ref<string[]>([])
  const availableLocales = ref<string[]>(['en'])

  return { branding, features, availableLocales }
})
